import React, { Component } from "react";
import {
  getBranch,
  getRegion,
  getDepartment,
  main_url,
  getFirstDayOfMonth,
} from "../../utils/CommonFunction";
import DatePicker from "react-datetime";
import moment from "moment";
import Select from "react-select";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "jspdf-autotable";
import { getHeaders } from "../../utils/apiHelper";
const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

class AbsenceReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branch: [],
      region: [],
      department: [],
      branchId: null,
      regionId: null,
      departmentId: null,
      from_date: moment(getFirstDayOfMonth()),
      to_date: moment(),
      EmployeeNameList: [],
      selectedEmployeeName: null,
      array_one: "",
      loading: false,
    };
  }

  async componentDidMount() {
    this.$el = $(this.el);
    this.setState(
      {
        dataSource: this.props.data,
      },
      () => {
        this._setTableData(this.state.dataSource);
      }
    );

    let branch = await getBranch();
    branch.unshift({ label: "All", value: 0 });
    let department = await getDepartment();
    department.unshift({ label: "All", value: 0 });
    let region = await getRegion();
    region.unshift({ state_name: "ALL", state_id: 0 });
    this.setState({
      branch: branch,
      department: department,
      region: region.map((v) => ({
        ...v,
        label: v.state_name,
        value: v.state_id,
      })),
    });
    this.getEmployeeName();
    this.handleSearchData();
  }
  getEmployeeName() {
    fetch(`${main_url}report/employeeName`, {
            headers: getHeaders(),
        })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ value: 0, label: "All" });
        this.setState({
          EmployeeNameList: list.map((v) => ({
            ...v,
          })),
        });
      });
  }
  handleSelectedBranch = async (event) => {
    this.setState({
      branchId: event,
    });
  };
  handleSelectedEmployeeName = async (event) => {
    this.setState({
      selectedEmployeeName: event,
    });
  };

  handleSelectedDepartment = async (event) => {
    this.setState({
      departmentId: event,
    });
  };
  handleSelectedRegion = async (event) => {
    this.setState({
      regionId: event,
    });
  };
  handleSelectedFromdate = async (event) => {
    this.setState({
      from_date: event,
    });
  };
  handleSelectedTodate = async (event) => {
    this.setState({
      to_date: event,
    });
  };
  handleSearchData = () => {
    this.setState({
      loading: true,
    });
    fetch(
      `${main_url}attendance/absenceReport/${moment(
        this.state.from_date
      ).format("YYYY-MM-DD")}/${moment(this.state.to_date).format(
        "YYYY-MM-DD"
      )}/${this.state.branchId ? this.state.branchId.value : 0}/${
        this.state.departmentId ? this.state.departmentId.value : 0
      }/${this.state.regionId ? this.state.regionId.value : 0}/${
        this.state.selectedEmployeeName
          ? this.state.selectedEmployeeName.value
          : 0
      }`, {
        headers: getHeaders(),
      }
    )
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        if (list != undefined && list.length > 0) {
          var absenceData = [];
          for (let i = 0; i < list.length; i++) {
            absenceData.push(list[i].absent);
          }
          this.setState({
            //array_one:list[i].absent
            loading: false,
            array_one: absenceData,
          });
        } else {
          this.setState({ loading: false, array_one: [] });
        }
        this._setTableData(this.state.array_one);
      });
  };

  _setTableData = (data) => {
    var table;
    var l = [];
    let rollNumber = 0;
    if (data) {
      for (var j = 0; j < data.length; j++) {
        let result = data[j];
        for (var i = 0; i < result.length; i++) {
          let obj = [];
          rollNumber = rollNumber > 0 ? rollNumber + 1 : i + 1;
          obj = {
            no: rollNumber,
            /* employee_id:data[i].employment_id ? data[i].employment_id :"-",
                employee_name:data[i].fullname ? data[i].fullname : "-",
                designation:data[i].designations ? data[i].designations : "-",
                region:data[i].state_name ? data[i].state_name : '-',
                branch: data[i].location_master_name ? data[i].location_master_name: "-",
                department:data[i].deptname ? data[i].deptname : "-",
                date:data[i].date ? data[i].date : "-",
                */
            employee_id: result[i].employment_id
              ? result[i].employment_id
              : "-",
            employee_name: result[i].fullname ? result[i].fullname : "-",
            designation: result[i].designations ? result[i].designations : "-",
            region: result[i].state_name ? result[i].state_name : "-",
            branch: result[i].location_master_name
              ? result[i].location_master_name
              : "-",
            department: result[i].deptname ? result[i].deptname : "-",
            date: result[i].date ? result[i].date : "-",
          };

          l.push(obj);
        }
      }
    }
    if ($.fn.dataTable.isDataTable("#dataTables-table")) {
      table = $("#dataTables-table").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-table").empty();
    }
    var column = [
      { title: "No", data: "no" },
      { title: "Date", data: "date" },
      { title: "Employee Id", data: "employee_id" },
      { title: "Employee Name", data: "employee_name" },
      { title: "Position", data: "designation" },
      { title: "Region", data: "region" },
      { title: "Branch", data: "branch" },
      { title: "Department", data: "department" },
    ];
    table = $("#dataTables-table").DataTable({
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      pageLength: 50,
      paging: true,
      buttons: true,
      dom: "Bfrtip",
      buttons: [
        "excel",
        //     //     'copy', 'csv', 'excel', 'pdf'
      ],
      buttons: [
        //         // 'copy',
        //         // {
        //         //         extend: 'csvHtml5',
        //         //         title: 'Child Benefit',
        //         // },
        {
          extend: "excelHtml5",
          title: "Absence Report",
        },
        //         // {
        //         //     extend: 'pdfHtml5',
        //         //     title: 'Child Benefit',
        //         // }
      ],
      data: l,
      columns: column,
    });
  };

  render() {
    if (this.state.loading === true) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <h2>Loading...</h2>
        </div>
      );
    } else {
      return (
        <div>
          <div className="row  white-bg dashboard-header">
            <h3 className="" style={{ paddingLeft: "10px" }}>
              Absence Report
            </h3>
            <div
              className="flex-row"
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                margin: "10px 10px 10px 10px",
              }}
            >
              <div style={{ marginRight: 10, width: 150 }}>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  value={this.state.from_date}
                  onChange={this.handleSelectedFromdate}
                  timeFormat={false}
                />
              </div>
              <div style={{ marginRight: 10, width: 150 }}>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  value={this.state.to_date}
                  onChange={this.handleSelectedTodate}
                  timeFormat={false}
                />
              </div>
              <Select
                styles={{
                  container: (base) => ({
                    ...base,
                    //   flex: 1
                    width: 150,
                    marginRight: 10,
                  }),
                  control: (base) => ({
                    ...base,
                    minHeight: "18px",
                  }),
                }}
                placeholder="Branch"
                options={this.state.branch}
                onChange={this.handleSelectedBranch}
                value={this.state.branchId}
                className="react-select-container"
                classNamePrefix="react-select"
              />
              <Select
                styles={{
                  container: (base) => ({
                    ...base,
                    //   flex: 1
                    width: 150,
                    marginRight: 10,
                  }),
                  control: (base) => ({
                    ...base,
                    minHeight: "18px",
                  }),
                }}
                placeholder="Region"
                options={this.state.region}
                onChange={this.handleSelectedRegion}
                value={this.state.regionId}
                className="react-select-container"
                classNamePrefix="react-select"
              />

              <Select
                styles={{
                  container: (base) => ({
                    ...base,
                    //   flex: 1
                    width: 150,
                  }),
                  control: (base) => ({
                    ...base,
                    minHeight: "18px",
                  }),
                }}
                placeholder="Department"
                options={this.state.department}
                onChange={this.handleSelectedDepartment}
                value={this.state.departmentId}
                className="react-select-container"
                classNamePrefix="react-select"
              />
              <Select
                styles={{
                  container: (base) => ({
                    ...base,
                    //   flex: 1
                    width: 150,
                    marginLeft: 10,
                  }),
                  control: (base) => ({
                    ...base,
                    minHeight: "18px",
                  }),
                }}
                placeholder="Employee Name"
                options={this.state.EmployeeNameList}
                onChange={this.handleSelectedEmployeeName}
                value={this.state.selectedEmployeeName}
                className="react-select-container"
                classNamePrefix="react-select"
              />

              <button
                className="btn btn-primary text-center"
                style={{
                  marginLeft: 10,
                  height: 30,
                  padding: "0px 5px 0px 5px",
                }}
                onClick={() => this.handleSearchData()}
              >
                Search
              </button>
            </div>

            <table
              width="99%"
              className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive"
              id="dataTables-table"
            />
          </div>
        </div>
      );
    }
  }
}
export default AbsenceReport;
